import React from "react";
import { Button } from "antd";
import AddAdminAccount from "../../components/tables/AddAdminAccount";

const AddAdminAccountPage = () => {
	return (
		<>
			<AddAdminAccount button={Button} />
		</>
	);
};

export default AddAdminAccountPage;
